import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import { Controller, useForm, FormContext } from 'react-hook-form';
import { useChangeBillingAddress } from '../css/useChangeBillingAddress';
import { useHistory } from 'react-router-dom';
import MyEirRegisterHeader from '../../sharedcomponents/MyEirPostpayRegistration/reusable/MyEirRegisterHeader';
import { MyEirChangeBillingAddressFinder } from './MyEirChangeBillingAddressFinder';
import MyEirChangeBillingAddress from './MyEirChangeBillingAddress';

function MyEirChangeAddressContainer(props) {
    const containerRef = useRef(null);
    const [isOpen, setIsopen] = useState(false);
    const reactId = useRef(Math.random().toString(36).slice(2, 9));
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = 'Change billing address';
    const descriptionId = `Change billing address description`;
    const classes = useChangeBillingAddress();
    function toggle() {
        setIsopen(!isOpen);
    }
    const [step, setStep] = useState(0);
    const [addressData, setAddressData] = useState(false);
    const [manualaddress, setManualAddress] = useState(false);

    const resetStep = () => {
        if (step !== 0) {
            setStep(0);
            props.toggle();
        }
    };

    const handleBack = () => {
        if (step == 0) {
            props.toggle();
            return;
        }
        setStep(step - 1);
    };

    const handleNext = (jumpTo = undefined) => {
        if (jumpTo != undefined) setStep(jumpTo);
        else {
            setStep(step + 1);
        }
    };

    const resetToDashboard = () => {
        if (step !== 0) {
            setStep(0);
        }
    };
    // useEffect(() => {
    //     if (props.isOpen) {
    //         document.getElementById(titleId)?.focus();
    //     }
    // }, [props.isOpen, titleId]);
    useEffect(() => {
        if (props.isOpen) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [props.isOpen]);

    return (
        <React.Fragment>
            <Modal
                className='changeAddress-main'
                wrapClassName={classes.changeAddressWrapper}
                modalClassName='changeAddress-modal'
                backdropClassName='changeAddress-backdrop'
                contentClassName='changeAddress-content'
                isOpen={props.isOpen}
                toggle={props.toggle}
                onClosed={resetToDashboard}
                role='dialog'
                aria-modal='true'
                aria-labelledby={titleId}
                aria-describedby={descriptionId}
                ref={containerRef}
                centered
            >
                <ModalBody className='changeAddress-body'>
                    <div className='changeAddress-body-content'>
                        <MyEirRegisterHeader
                            headerText={'Change billing address'}
                            handleBackButton={handleBack}
                            id={titleId}
                        />

                        {
                            {
                                0: (
                                    <MyEirChangeBillingAddressFinder
                                        handleBackButton={handleBack}
                                        handleNext={handleNext}
                                        setAddressData={setAddressData}
                                        setManualAddress={setManualAddress}
                                        descId={descriptionId}
                                    />
                                ),

                                1: (
                                    <MyEirChangeBillingAddress
                                        handleBackButton={handleBack}
                                        handleNext={handleNext}
                                        resetStep={resetStep}
                                        addressData={addressData}
                                        isManual={manualaddress}
                                        toggle={props.toggle}
                                        descId={descriptionId}
                                    />
                                ),
                            }[step]
                        }
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default MyEirChangeAddressContainer;
